import styled from 'styled-components';
import * as GStyled from '../../../../styles/components/Text.styled';

const SubCategoryHeaderLabel = styled(GStyled.Text).attrs(() => ({
  size: 'sm',
}))`
  color: ${(props): string => props.theme.colors.lightOrange};
`;

export { SubCategoryHeaderLabel };
